import { render, staticRenderFns } from "./InfoBubble.vue?vue&type=template&id=24383f12&scoped=true"
import script from "./InfoBubble.vue?vue&type=script&lang=js"
export * from "./InfoBubble.vue?vue&type=script&lang=js"
import style0 from "./InfoBubble.vue?vue&type=style&index=0&id=24383f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24383f12",
  null
  
)

export default component.exports